import { getBodyData } from '../../selectors';
/**
 * Tariff selectors
 */
export const getBodyIsTariffFlag = (state) => getBodyData(state).isTariff || false;
